module.exports = __webpack_public_path__ + "static/STG20_Mobile_480_Module5_Drink1_Royal-b0e331f75f1e9343ce910958d6c0f8ff.png";